import { Box, styled } from 'styled-system/jsx';

import { Footer, FooterConfirmButton,FooterMobile } from './Footer/Footer';
import { Inputs } from './Inputs';
import { Toggles } from './Toggles';

type Props = {};
export const TradeModule = ({}: Props) => {
  return (
    <Root data-cy="TradeModule">
      <Toggles />
      <Body />
    </Root>
  );
};

const Root = styled(Box, {
  base: {
    bg: 'v2.bg.panel',
    h: 'full',
  },
});

const Body = () => {
  return (
    <Box p="0px 12px 12px">
      {/* Price / Collateral / TPSL */}
      <Inputs />
      <Foot mt="11px" />
    </Box>
  );
};

const Foot = Footer;

TradeModule.Root = Root;

TradeModule.Head = Toggles;

TradeModule.Body = Body;

TradeModule.Inputs = Inputs;

TradeModule.Foot = Foot;

TradeModule.FooterMobile = FooterMobile;
TradeModule.FooterConfirmButton = FooterConfirmButton;
